export var defaultGridSize = 8;

export var defaultGridColumns = 12;

export var defaultGridColumnWidth = defaultGridSize * 10;

export var spacing = {
  comfortable: defaultGridSize * 5,
  cosy: defaultGridSize * 2,
  compact: defaultGridSize * 0.5
};

export var layout = ['fixed', 'fluid'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/page/dist/esm/internal/vars.js
// module id = 91
// module chunks = 0